/* eslint-disable */
<!-- // components/DocPagination.vue -->
<template>
  <div class="doc-pagination">
    <div class="prev" v-if="prev">
      <router-link :to="`/docs/${prev.slug}`">
        <span class="label">上一页</span>
        <span class="title">{{ prev.title }}</span>
      </router-link>
    </div>
    <div class="spacer" v-if="!prev || !next"></div>
    <div class="next" v-if="next">
      <router-link :to="`/docs/${next.slug}`">
        <span class="label">下一页</span>
        <span class="title">{{ next.title }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'DocPagination',
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    
    const navigation = computed(() => {
      return store.getters.getDocNavigation(props.slug)
    })
    
    const prev = computed(() => navigation.value.prev)
    const next = computed(() => navigation.value.next)
    
    return {
      navigation,
      prev,
      next
    }
  }
}
</script>

<style scoped>
.doc-pagination {
  display: flex;
  margin-top: 50px;
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.prev, .next, .spacer {
  flex: 1;
}

.prev a, .next a {
  display: block;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  text-decoration: none;
  color: var(--text-color);
  transition: all 0.2s;
}

.prev a:hover, .next a:hover {
  border-color: var(--primary-color);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.label {
  display: block;
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 5px;
}

.title {
  display: block;
  font-weight: 500;
  color: var(--primary-color);
}

.next {
  text-align: right;
}

.prev a {
  padding-left: 30px;
  position: relative;
}

.next a {
  padding-right: 30px;
  position: relative;
}

.prev a:before, .next a:after {
  content: '';
  position: absolute;
  top: 50%;
  border: solid var(--primary-color);
  border-width: 0 2px 2px 0;
  padding: 3px;
  margin-top: -3px;
}

.prev a:before {
  left: 15px;
  transform: rotate(135deg);
}

.next a:after {
  right: 15px;
  transform: rotate(-45deg);
}

@media (max-width: 576px) {
  .doc-pagination {
    flex-direction: column;
    gap: 15px;
  }
  
  .prev, .next {
    width: 100%;
  }
  
  .spacer {
    display: none;
  }
}
</style>